import React from "react";
import { Pressable } from "../../ui/pressable";
import { Text } from "../../ui/text";

interface FilterChipProps {
  label: string;
  active: boolean;
  onPress: () => void;
}

/** A togglable filter chip. Active styling is CSS-driven via `aria-selected`. */
export const FilterChip = React.memo(
  ({ label, active, onPress }: FilterChipProps) => (
    <Pressable
      onPress={onPress}
      aria-selected={active}
      className={`rounded-full border px-3 py-1 border-outline-200 bg-background-0 aria-selected:border-brand-500 aria-selected:bg-brand-50 group`}
    >
      <Text
        size="xs"
        className={
          "text-typography-600 group-aria-selected:text-brand-600 group-aria-selected:font-bold"
        }
      >
        {label}
      </Text>
    </Pressable>
  ),
);
FilterChip.displayName = "FilterChip";

export default FilterChip;
